<template>
  <el-dialog
    :title="title"
    :visible.sync="innerVisible"
    :width="dialogWidth"
    :close-on-click-modal="false"
    @close="closeHandler"
  >
    <el-form v-if="elementformulaEditable" inline>
      <el-form-item :label="$t('CargoMsg.Cargo_AccountTitle')">
        <el-select ref="accountTitleRef" v-model="form.accountTitle" style="width: 300px;":filterable="true":clearable="true" no="1">
          <el-option
            v-for="(item,index) in accountTitleCollection"
            :key="index"
            :label="accountTitleLabelFun(item)"
            :value="item.accountTitle"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_OperationSymbol')">
        <el-select v-model="form.operateMode" style="width: 80px;" no="2">
          <el-option label="+" :value="1" />
          <el-option label="-" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" no="3" @click="addAccountTitleBtnClickHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
      </el-form-item>
    </el-form>
    <div>
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;height:300px;padding-left:2px"
      />
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="footer.gridOptions"
        :column-defs="columnDefs2"
        :row-data="footer.rowData"
        :auto-fit-content="false"
        class="accounting-document-grid accounting-document-grid-footer"
        style="width:100%;padding-left:2px"
      />
    </div>
    <div slot="footer" style="padding-right:280px">
      <el-button v-if="elementformulaEditable" type="primary" no="4" @click="saveHander">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button no="5" @click="closeHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import * as statementDescriptionApi from '@/api/financeManage/statementDescription'
import * as statementElementDescriptionApi from '@/api/financeManage/statementElementDescription'
import * as NumberUtils from '@/utils/NumberUtils'
import { DocumentManage } from '@/utils/commonUtil'

export default {
  name: 'ElementFormulaEditDialog',
  props: {
    visible: { type: Boolean, required: true },
    atbDictionary: { type: Object, required: true },
    accountSet: { type: Object, default: null },
    elementformulaEditable: { type: Boolean, required: true, default: false },
    statementElementDescriptionUuid: { type: String, required: true },
    statementName: { type: String, required: true },
    fiscalPeriod: { type: Object, required: true },
    statementElementDescription: { type: Object, required: true }
  },
  data() {
    return {
      // statementElementDescription: {},
      documentManage: new DocumentManage(),
      innerVisible: false,
      form: {
        accountTitle: '',
        operateMode: 1
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          sortable: false // 去掉每列的排序
        },
        suppressContextMenu: true
      },
      rowData: [],
      footer: {
        gridOptions: {
          alignedGrids: [],
          headerHeight: 0,
          suppressContextMenu: true,
          suppressRowSelection: true,
          suppressRowClickSelection: true,
          rowHeight: 30,
          defaultColDef: {
            suppressMenu: true,
            suppressMovable: true,
            headerClass: 'text-center'
          }
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
            field: 'accountTitle',
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_OperationSymbol'),
            field: 'operateMode',
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_PeriodEndAmount'),
            field: 'ending',
            width: 150,
            valueFormatter: params => {
              return params.value ? NumberUtils.formatRoundNumber(params.value, 2) : ''
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_OpeningAmountOfTheYear'),
            field: 'beginningYear',
            width: 150,
            valueFormatter: params => {
              return params.value ? NumberUtils.formatRoundNumber(params.value, 2) : ''
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Operation'),
            field: '',
            hide: !this.elementformulaEditable,
            width: 150
          }
        ],
        rowData: [
          {
            accountTitle: this.$t('FinanceManage.Total'),
            ending: '',
            beginningYear: ''
          }
        ]
      }
    }
  },
  computed: {
    // 科目
    accountTitleCollection() {
      return this.accountSet ? this.accountSet.accountTitle : []
    },
    title() {
      return this.$t('CargoMsg.Cargo_EditFormula') + this.statementElementDescription.name
    },
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
          field: 'accountTitle',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperationSymbol'),
          field: 'operateMode',
          width: 100,
          valueFormatter: params => {
            return this.operateModeFun(params.value)
          },
          cellStyle: { textAlign: 'center' }
        },
        {
          headerName: this.endingHeadName(),
          field: 'ending',
          width: 140,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.beginningYearHeadName(),
          field: 'beginningYear',
          width: 140,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          hide: !this.elementformulaEditable,
          width: 80,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('delete')
            const del = this.$t('CargoMsg.Cargo_Delete')
            return `<a onclick="${methodPath}('${params.rowIndex}')" style="color: red;text-decoration: underline;">${del}</a>`
          },
          cellStyle: { textAlign: 'center' }
        }
      ]
    },
    columnDefs2() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
          field: 'accountTitle',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperationSymbol'),
          field: 'operateMode',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PeriodEndAmount'),
          field: 'ending',
          width: 140,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OpeningAmountOfTheYear'),
          field: 'beginningYear',
          width: 140,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          hide: !this.elementformulaEditable,
          width: 80
        }
      ]
    },
    dialogWidth() {
      return this.elementformulaEditable ? '705px' : '625px'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        // 加载列表数据
        this.loadData()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.$emit('close')
      }
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('delete', function(data) {
      self.deleteClickHandler(data)
    })
  },
  methods: {
    async loadData() {
      if (!this.statementElementDescriptionUuid) return
      // const statementElementDescription = await statementElementDescriptionApi.detail({ uuid: this.statementElementDescriptionUuid }).then(resp => resp.data)
      // if (statementElementDescription) {
      //   this.statementElementDescription = statementElementDescription
      await this.fillItem(this.statementElementDescription)
      // }
      this.total()
    },
    accountTitleLabelFun(accountTitle) {
      return accountTitle ? accountTitle.accountTitle + '_' + accountTitle.accountTitleName : ''
    },
    operateModeFun(value) {
      return value ? '+' : '-'
    },
    async addAccountTitleBtnClickHandler() {
      if (!this.form.accountTitle) {
        return
      }
      if (!this.rowData) this.rowData = []
      const elementFormula = {}
      elementFormula.accountTitle = this.form.accountTitle
      elementFormula.operateMode = this.form.operateMode
      this.rowData.push(await this.creatItem(elementFormula))
      this.clearForm()
      this.total()
    },
    async creatItem(elementFormula) {
      const ac = this.getAccountTitle(elementFormula.accountTitle)
      const atb = this.getAccountTitleBalance(elementFormula.accountTitle)
      if (ac && atb) {
        const result = {}
        result.elementFormula = elementFormula
        result.key = elementFormula.accountTitle
        result.accountTitle = elementFormula.accountTitle + ' ' + ac.accountTitleName
        result.operateMode = elementFormula.operateMode
        if (this.statementName === 'BalanceSheetStatement') {
          result.beginningYear = atb.beginningBalance
          result.ending = atb.currentMonthBalanceAmount
        } else {
          result.beginningYear = atb.currentMonthTotalAmount
          result.ending = atb.currentYearTotalAmount
        }
        return result
      } else {
        // ac;
        const result = {}
        result.elementFormula = elementFormula
        result.key = elementFormula.accountTitle
        result.accountTitle = elementFormula.accountTitle + ' ' + (ac ? ac.accountTitleName : '')
        result.operateMode = elementFormula.operateMode
        if (this.statementName === 'BalanceSheetStatement') {
          result.beginningYear = 0
          result.ending = 0
        } else {
          result.beginningYear = 0
          result.ending = 0
        }
        return result
      }
    },
    clearForm() {
      this.form.accountTitle = ''
      this.form.operateMode = 1
    },
    getAccountTitle(accountTitle) {
      if (!this.accountTitleCollection || !accountTitle) {
        return null
      }
      return this.accountTitleCollection.find(title => title.accountTitle === accountTitle)
    },
    getAccountTitleBalance(accountTitle) {
      return this.atbDictionary[accountTitle]
    },
    saveHander() {
      if (this.statementElementDescription.elementFormula) {
        this.statementElementDescription.elementFormula = []
      }
      for (const item of this.rowData) {
        if (!this.statementElementDescription.elementFormula) {
          this.statementElementDescription.elementFormula = []
        }
        if (!item.elementFormula.uuid) {
          item.elementFormula.elementDescriptionUuid = this.statementElementDescription.uuid
        }
        this.statementElementDescription.elementFormula.push(item.elementFormula)
      }
      const loading = getLoading()
      statementElementDescriptionApi.save(this.statementElementDescription).then(resp => {
        this.closeHandler()
      }).finally(() => loading.close())
      // this.statementElementDescription.save2(saveResultHandler, saveFaultHandler);
    },
    deleteClickHandler(rowIndex) {
      this.rowData.splice(rowIndex, 1)
    },
    closeHandler() {
      this.clearForm()
      this.$emit('close')
    },
    async fillItem(value) {
      this.rowData = []
      if (!value.elementFormula || value.elementFormula.length === 0) return
      for (const elementFormula of value.elementFormula) {
        this.rowData.push(await this.creatItem(elementFormula))
      }
    },
    // 合计
    total() {
      let ending = 0
      let beginningYear = 0
      for (const row of this.rowData) {
        ending += Number(row.ending)
        beginningYear += Number(row.beginningYear)
      }
      this.footer.rowData[0].ending = ending
      this.footer.rowData[0].beginningYear = beginningYear
      this.footer.gridOptions.api.refreshCells({ force: true })
    },
    endingHeadName() {
      if (this.statementName === 'BalanceSheetStatement') {
        return this.$t('CargoMsg.Cargo_PeriodEndAmount')
      } else {
        return this.$t('CargoMsg.Cargo_CurrentYearAccumulatedAmount')
      }
    },
    beginningYearHeadName() {
      if (this.statementName === 'BalanceSheetStatement') {
        return this.$t('CargoMsg.Cargo_OpeningAmountOfTheYear')
      } else {
        return this.$t('CargoMsg.Cargo_AmountOfCurrentMonth')
      }
    }
  }
}
</script>

<style lang="scss">
.accounting-document-grid{
  .ag-cell-inline-editing {
    height: 100%!important;
  }
  .ag-header-cell{
    &.text-center {
      text-align: center;
      .ag-header-cell-text{
        display: inline;
        width: 100%;
        height: 100%;
        line-height: 64px;
      }
    }
    &::after {
      height: 48px;
    }
  }
  .ag-cell {
    border-right: 1px solid #d9dcde;
  }
  .ag-cell-inline-editing {
    height: 30px;
  }
  &-footer {
    height: 34px;
    .ag-theme-balham {
      min-height: 34px!important;
    }
  }
}

</style>
